import { Grid } from "@mui/material";
import { currencyRound } from "../../util/DoubleUtil";

const CartaoCreditoTransacaoView = ({ cartaoCreditoTransacao }) => {
  return (
    <Grid container spacing={3}>
      <Grid size={12} sx={{ fontWeight: "bold", fontSize: 20 }}>
        Cartão Crédito Transação
      </Grid>
      <Grid>
        <span style={{ fontWeight: "bold" }}>Código: </span>
        {cartaoCreditoTransacao?.codigo}
      </Grid>
      <Grid>
        <span style={{ fontWeight: "bold" }}>Nome Impresso: </span>
        {cartaoCreditoTransacao?.nomeImpresso}
      </Grid>
      <Grid>
        <span style={{ fontWeight: "bold" }}>Número Cartão: </span>
        {cartaoCreditoTransacao?.numeroCartao}
      </Grid>
      <Grid>
        <span style={{ fontWeight: "bold" }}>Valor: </span>
        {currencyRound(cartaoCreditoTransacao?.valor)}
      </Grid>
      <Grid>
        <span style={{ fontWeight: "bold" }}>
          Cartão Forma Pagamento(0 = A Vista; * 1 = Parcelado sem juros; * 2 =
          Parcelado com juros):{" "}
        </span>
        {cartaoCreditoTransacao?.cartaoFormaPagamento}
      </Grid>
      <Grid>
        <span style={{ fontWeight: "bold" }}>Quant. Parcelas: </span>
        {cartaoCreditoTransacao?.quantidadeParcelas}
      </Grid>
      <Grid>
        <span style={{ fontWeight: "bold" }}>Cliente Descrição: </span>
        {cartaoCreditoTransacao?.clienteDescricao}
      </Grid>
      <Grid>
        <span style={{ fontWeight: "bold" }}>Cliente IP: </span>
        {cartaoCreditoTransacao?.clienteIP}
      </Grid>
      <Grid>
        <span style={{ fontWeight: "bold" }}>Cliente CPF/CNPJ: </span>
        {cartaoCreditoTransacao?.clienteCpfCnpj}
      </Grid>
      <Grid>
        <span style={{ fontWeight: "bold" }}>Cliente Nome: </span>
        {cartaoCreditoTransacao?.clienteNome}
      </Grid>
      <Grid>
        <span style={{ fontWeight: "bold" }}>Cliente Email: </span>
        {cartaoCreditoTransacao?.clienteEmail}
      </Grid>
      <Grid>
        <span style={{ fontWeight: "bold" }}>Nº Pedido: </span>
        {cartaoCreditoTransacao?.numeroPedido}
      </Grid>
      <Grid>
        <span style={{ fontWeight: "bold" }}>Retorno: </span>
        {cartaoCreditoTransacao?.retorno}
      </Grid>
      <Grid>
        <span style={{ fontWeight: "bold" }}>Detalhes Erro: </span>
        {cartaoCreditoTransacao?.detalhesErro}
      </Grid>
      <Grid>
        <span style={{ fontWeight: "bold" }}>Identificador: </span>
        {cartaoCreditoTransacao?.identificador}
      </Grid>
      <Grid>
        <span style={{ fontWeight: "bold" }}>Cód. Autorização: </span>
        {cartaoCreditoTransacao?.codigoAutorizacao}
      </Grid>
      <Grid>
        <span style={{ fontWeight: "bold" }}>NSU Operação: </span>
        {cartaoCreditoTransacao?.nsuOperacao}
      </Grid>
      <Grid>
        <span style={{ fontWeight: "bold" }}>Adquirente: </span>
        {cartaoCreditoTransacao?.adquirente}
      </Grid>
      <Grid>
        <span style={{ fontWeight: "bold" }}>Nº Autorização: </span>
        {cartaoCreditoTransacao?.numeroAutorizacao}
      </Grid>
    </Grid>
  );
};

export default CartaoCreditoTransacaoView;
